import React from 'react';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import Button, { Appearance } from '@atlaskit/button';
import { Text, Flex } from '@atlaskit/primitives';

type InfoDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  infoContent: string;
  title: string;
  submitButtonText: string;
  handleSubmit: () => void;
  closeButtonText?: string;
  submitButtonAppearance?: Appearance;
  height?: number;
};

export const InfoDialog = ({
  isOpen,
  onClose,
  infoContent,
  title,
  submitButtonText,
  handleSubmit,
  closeButtonText = 'Close',
  submitButtonAppearance = 'primary',
  height = 240,
}: InfoDialogProps) => {
  return (
    <ModalTransition>
      {isOpen && (
        <Modal onClose={onClose} height={height} width={400} testId="info-dialog">
          <ModalHeader>
            <ModalTitle>{title}</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <Text color={'color.text.subtle'}>{infoContent}</Text>
          </ModalBody>
          <ModalFooter>
            <Flex gap="space.100">
              <Button appearance="subtle" onClick={onClose} testId="close-info-dialog">
                {closeButtonText}
              </Button>
              <Button appearance={submitButtonAppearance} onClick={handleSubmit} autoFocus testId="submit-info-dialog">
                {submitButtonText}
              </Button>
            </Flex>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};
